import {observer} from "mobx-react";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import {IconButton} from "@mui/material";
import React from "react";
import {useStores} from "../../Hooks";

const TtsMuteButton = observer(({isPreview}) => {
    const {procedureStore} = useStores();
    const Icon = !procedureStore.ttsMuted ? VolumeUpIcon : VolumeOffIcon;
    return (
        <IconButton onClick={() => procedureStore.toggleTtsMuted(isPreview)} className='mute-tts-button'>
            <Icon htmlColor='white'/>
        </IconButton>
    )
});

export default TtsMuteButton;
